import React, { Fragment } from "react";
import PropTypes from "prop-types";
import * as types from "../../../constants/ComponentConstants";
import Section from "../../common/Section";
import Table from "../../common/Table";
import { Popup } from 'semantic-ui-react';
import Form from "../../common/Form";
import { UserTypes } from "../../../constants/DomainConstants";

const AdresOverzichtForm = (props) => {
    const {
        model,
        onSortTable,
        onDelete,
        onClickEdit,
        onSave,
        onUndo,
        undoButtonDisabled,
        disabled,
        landen,
        adresTypes,
        beschrCorrespAdressen,
        userType,
        errors
    } = props;

    function mapOnDelete(id) {
        return function (event) {
            onDelete(id, event);
        };
    }

    function mapOnClickEdit(index) {
        return function () {
            onClickEdit(index);
        };
    }

    function returnTdContent(text) {
        return text.length > 90 ? <Popup wide="very" position="top left" trigger={<p>{text.substring(0, 80) + "..."}</p>} content={text} /> : text;
    }

    const tdStyle = { padding: "5px" };


    const localAdresRows = model.adressen.filter(a => !a.internationaalAdres && (a.toDelete == "false" || a.toDelete === false)).map((adres, i) => {
        const postcodeEnGemeente = (adres.postcode ? adres.postcode : "") + " " + (adres.gemeente ? adres.gemeente : "");
        const nrEnBus = (adres.huisnummer ? adres.huisnummer : "") + (adres.busnummer ? "/" + adres.busnummer : "");
        const landNaam = adres.land ? landen.find(x => x.value === adres.land).label : '';
        const soortAdresNaam = adres.soortAdres ? adresTypes.find(x => x.value === adres.soortAdres)?.label : '';
        let beschrijvingAdres = undefined;
        if(soortAdresNaam === "Exploitatieadres")
            beschrijvingAdres = adres.beschrExplAdr;
        if(soortAdresNaam === "Correspondentieadres")
            beschrijvingAdres = adres.beschrCorrespAdrEnum ? beschrCorrespAdressen.find(x => x.beschrCorrespAdrEnum == adres.beschrCorrespAdrEnum)?.naam : '';
        

        return (<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }} key={i}>
            <td style={tdStyle}>{soortAdresNaam}{soortAdresNaam === "Exploitatieadres" && userType === UserTypes.WEBSITEBEZOEKER ?
                <Popup wide="very" trigger={<i className="fa fa-info-circle" style={{ cursor: 'pointer', "margin": "0 5px" }} src={require('../../../images/idIcon.jpg')} />} content={"Indien er geen officiële sportinfrastructuur bekend is, wordt een exploitatieadres gebruikt als adres waar de trainingen/thuiswedstrijden doorgaan."} position="left center" />
                : null}</td>
            <td style={tdStyle}>{adres.straat}</td>
            <td style={tdStyle}>{nrEnBus}</td>
            <td style={tdStyle}>{postcodeEnGemeente}</td>
            <td style={tdStyle}>{landNaam}</td>
            <td style={tdStyle}>
            {beschrijvingAdres && <Popup trigger={<span style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: 'pointer' }}><i className="fa fa-file-text-o fa-fw"></i></span>} content={beschrijvingAdres} />}
            <span onClick={disabled ? null : mapOnClickEdit(adres.id)} style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: disabled ? 'not-allowed' : 'pointer' }}><i className="fa fa-pencil fa-fw" /></span>
                <Popup trigger={<span onClick={disabled ? null : mapOnDelete(adres.id)} style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: disabled ? 'not-allowed' : 'pointer' }}><i className="fa fa-remove fa-fw"></i></span>} content={"Verwijder adres"} />
            </td>
        </tr>);
    });

    const internationalAdresRows = model.adressen.filter(a => a.internationaalAdres && (a.toDelete == "false" || a.toDelete === false)).map((adres, i) => {
        let beschrijvingAdres = undefined;
        if(soortAdresNaam === "Exploitatieadres")
            beschrijvingAdres = adres.beschrExplAdr;
        if(soortAdresNaam === "Correspondentieadres")
            beschrijvingAdres = adres.beschrCorrespAdrEnum ? beschrCorrespAdressen.find(x => x.beschrCorrespAdrEnum === adres.beschrCorrespAdrEnum)?.naam : '';
        
        const landNaam = adres.land ? landen.find(x => x.value === adres.land).label : '';
        const soortAdresNaam = adres.soortAdres ? adresTypes.find(x => x.value === adres.soortAdres).label : '';
        return (<tr style={{ borderStyle: 'solid', borderWidth: "1px", borderColor: '#eeefef', height: '80' }} key={i}>
            <td style={tdStyle}>{soortAdresNaam}{soortAdresNaam === "Exploitatieadres" && userType === UserTypes.WEBSITEBEZOEKER ?
                <Popup wide="very" trigger={<i className="fa fa-info-circle" style={{ cursor: 'pointer', "margin": "0 5px" }} src={require('../../../images/idIcon.jpg')} />} content={"Indien er geen officiële sportinfrastructuur bekend is, wordt een exploitatieadres gebruikt als adres waar de trainingen/thuiswedstrijden doorgaan."} position="left center" />
                : null}</td>
            <td style={tdStyle}>{returnTdContent(adres.internationaalAdres)}</td>
            <td style={tdStyle}>{landNaam}</td>
            <td style={tdStyle}>
                {beschrijvingAdres && <Popup trigger={<span style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: 'pointer' }}><i className="fa fa-file-text-o fa-fw"></i></span>} content={beschrijvingAdres} />}
                <span onClick={disabled ? null : mapOnClickEdit(adres.id)} style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: disabled ? 'not-allowed' : 'pointer' }}><i className="fa fa-pencil fa-fw" style={{ cursor: 'pointer' }} /></span>
                <Popup trigger={<span onClick={disabled ? null : mapOnDelete(adres.id)} style={{ color: disabled ? '#eeefef' : '#777', fontSize: '1rem', cursor: disabled ? 'not-allowed' : 'pointer' }}><i className="fa fa-remove fa-fw"></i></span>} content={"Verwijder adres"} />
            </td>
        </tr>);
    });

    return (
        <Section
            title={"Adresgegevens"}
            color={types.COLOR_GREEN_LIGHT}
        >
            <Section>
                <Form name="adressen"
                    headerVisible={false}
                    isNotRequired
                    rightButtonLabel="Bewaren"
                    onRightButtonClick={onSave}
                    rightButtonDisabled={disabled}
                    leftButtonLabel="Voeg toe"
                    onLeftButtonClick={mapOnClickEdit()}
                    leftButtonDisabled={disabled}
                    onUndoButtonClick={onUndo}
                    error={errors ? errors['model'] : ""}
                    undoButtonVisible={!undoButtonDisabled}
                >
                    {model.adressen && model.adressen.length > 0 ?
                        <div>
                            {localAdresRows && localAdresRows.length > 0 && internationalAdresRows && internationalAdresRows.length > 0 ?
                                <h2 style={{ color: "#777" }}>Belgische adressen</h2> : null}
                            {localAdresRows && localAdresRows.length > 0 ?
                                <Table
                                    headers={["Soort Adres", "Straatnaam", "Nr - Bus", "Postcode - Gemeente", "Land", ""]}
                                    onClickHeader={onSortTable}
                                    sortableColumns={[1, 3]}
                                    headerSizes={[16, 24, 10, 18, 20, 8]}
                                >
                                    {localAdresRows}
                                </Table> : null}
                            {localAdresRows && localAdresRows.length > 0 && internationalAdresRows && internationalAdresRows.length > 0 ?
                                <h2 style={{ color: "#777" }}>Internationale adressen</h2> : null}
                            {internationalAdresRows && internationalAdresRows.length > 0 ?
                                <Table
                                    headers={["Soort Adres", "Internationaal adres", "Land", ""]}
                                    onClickHeader={onSortTable}
                                    headerSizes={[16, 52, 20, 8]}
                                >
                                    {internationalAdresRows}
                                </Table> : null}
                        </div>
                        :
                        null
                    }
                </Form>
            </Section>
        </Section>
    );
};

AdresOverzichtForm.propTypes = {
    model: PropTypes.object,
    onSortTable: PropTypes.func,
    onDelete: PropTypes.func,
    onClickEdit: PropTypes.func,
    onSave: PropTypes.func,
    onUndo: PropTypes.func,
    undoButtonDisabled: PropTypes.bool,
    disabled: PropTypes.bool,
    landen: PropTypes.array,
    errors: PropTypes.array,
    beschrCorrespAdressen: PropTypes.array,
    adresTypes: PropTypes.array,
    userType: PropTypes.string
};

export default AdresOverzichtForm;